/*
 * @Description:
 * @Author: shenah
 * @Date: 2023-04-28 10:15:42
 * @LastEditors: shenah
 * @LastEditTime: 2025-04-25 09:47:03
 */
import { filterConditionStrategy } from "./filterData.js";
import { handleColor } from "_dataview/output/config/commonConfig";
let objectToString = function (o, root) {
  if (o === null) {
    return "null,\n";
  } else if (typeof o === "string") {
    return JSON.stringify(o) + ",\n";
  } else if (typeof o === "function") {
    return o.toString() + ",";
  } else if (Array.isArray(o)) {
    let val = `[
      `;
    o.forEach((it) => {
      val += objectToString(it);
    });
    val += `]`;
    if (root) {
      return `${val}\n`;
    }
    return `${val},\n`;
  } else if (typeof o === "object") {
    let val = `{
      `;
    Object.keys(o).forEach((key) => {
      val += `"${key}":`;
      val += objectToString(o[key]);
    });
    val += `}`;
    if (root) {
      return `${val}\n`;
    }
    return `${val},\n`;
  } else {
    return `${o},\n`;
  }
};
/**
 * @description: 处理小数不用对象的方式传
 * @param {string|number} data 传入的数据
 * @param {number} digit 保留几位小数
 * @param {boolean} isKeep 是否保留0
 * @param {number} type 0代表四舍五入1代表向上取证2代表向下舍入
 * @return {string|number} 保留0就是字符串,不保留就是number
 */
let handleDecimal = (data, digit = -1, isKeep = false, type = 0) => {
  let nowData = Number(data);
  if (isNaN(nowData) || digit < 0 || digit > 100) {
    return data;
  }
  let methodObj = {
    0: _.round,
    1: _.ceil,
    2: _.floor,
  };
  let method = methodObj[type];
  if (!method) {
    return data;
  }
  nowData = method(nowData, digit);
  if (isKeep) {
    return nowData?.toFixed(digit) || data;
  }
  if (isNaN(nowData)) {
    return data;
  }
  return nowData;
};

let getRandomColor = () => {
  var r = Math.floor(Math.random() * 256); //生成红色0-255
  var g = Math.floor(Math.random() * 256); //生成绿色0-255
  var b = Math.floor(Math.random() * 256); //生成蓝色0-255
  return `rgb(${r},${g},${b})`;
};

//默认静态数据转化成luncysheet表格二维数据
const transformToExcelData = (data, desc) => {
  //字段数组
  let fields = Object.keys(desc);
  //字段名描述
  let fieldDesc = Object.values(desc);
  let res = [];
  res.push(["字段名", ...fields]);
  res.push(["字段名描述", ...fieldDesc]);

  for (let i = 0; i < data.length; i++) {
    let cell = data[i];
    let row = [null];
    fields.forEach((field) => {
      row.push(cell[field]);
    });
    if (row.length > 1) {
      res.push([...row]);
    }
  }
  return res;
};
//lunckysheet表格二维数据集转成JSON
const transformExcelDataToJSON = (data) => {
  if (!Array.isArray(data) || !Array.isArray(data[0]))
    return { res: [], mapList: [] };
  let res = [];
  let mapList = [];
  let fields = data[0];
  let decs = data[1];
  for (let i = 1; i < fields.length; i++) {
    let field = fields[i];
    mapList.push({
      name: decs[i] || field,
      value: field,
    });
  }
  for (let i = 2; i < data.length; i++) {
    let resData = {};
    let row = data[i];
    for (let j = 1; j < row.length; j++) {
      let str = row[j] || "";
      //字段名
      let key = fields[j];
      let value = str;
      resData[key] = value;
    }
    res.push(resData);
  }

  return { res, mapList };
};
/**
 * @name: 解析表格对象=>并转化为数组对象
 * @param {Array} res 表格对象
 * @return {*}
 */
let dataExcelCommonExcelToArrayObj = (res, callback) => {
  if (!res.length) return;
  const rows = res[0].rows;
  //字段映射表
  let fields = new Map();
  // 解析出字段
  Object.keys(rows[0].cells).forEach((key, index) => {
    if (index !== 0) {
      let field = rows[0].cells[key]?.text || 0;
      let aliasName = rows[1].cells[key]?.text || `未知字段${index + 1}`;
      fields.set(index, {
        name: aliasName,
        value: field,
      });
    }
  });

  let data = [];
  // 解析出数据
  Object.keys(rows).forEach((key) => {
    if (key !== "0" && key !== "1") {
      //数据项
      let row = rows[key].cells;
      //数据对象
      let item = {};
      let isEmpty = true;
      if (row && typeof row === "object") {
        for (let key of fields.keys()) {
          let field = fields.get(key).value;
          if (row[key] && row[key].text) {
            item[field] = row[key].text;
            isEmpty = false;
          } else {
            item[field] = undefined;
          }
        }
        if (!isEmpty) {
          data.push(item);
        }
      }
    }
  });
  if (callback) {
    callback([...fields.values()]);
  }
  return data;
};
/**
 * @name: 数字转化为千分位
 * @param {*} str 任意类型
 * @return {*} string
 */
let toThSeparator = (str) => {
  // 将数字转换为字符串
  if (!dsf.isNumber(str)) {
    return str;
  }
  let strNumber = str?.toString() || "";
  // 使用正则表达式添加千分位分隔符
  strNumber = strNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return strNumber;
};

/**
 * @description: 数字单位换算
 * @param {*} number 数据
 * @param {*} unitVal 分割量级(如10,100)
 * @param {*} decimalNum 小数位
 * @param {*} divider 分割符
 * @return {*} number
 */
let transformUnit = function (
  number,
  unitVal,
  isUnit = true,
  decimalNum,
  divider
) {
  let unitObj = dsf.dataview.units;
  let unit = unitObj[unitVal];
  if (!number || isNaN(Number(number))) {
    return number;
  }
  if (unit) {
    number = number / unitVal;
  }
  const strSplit = number.toString().split(".");
  const integer = strSplit[0];
  let decimal = strSplit[1] || "";
  if (decimalNum && decimal) {
    decimal = decimal.substr(0, decimalNum);
  }
  if (divider) {
    return (
      integer.replace(/\B(?=(\d{3})+(?!\d))/g, divider) +
      (decimal ? "." + decimal : "") +
      (isUnit ? unit : "")
    );
  }
  return integer + (decimal ? "." + decimal : "") + (isUnit ? unit : "");
};
let compatiblePathToExtendImg = function (obj, active = "custom") {
  if (!obj || typeof obj === "string") {
    return {
      active,
      custom: {
        image: obj ? obj : "",
        static: true,
        size: "cover",
        repeat: "no-repeat",
        position: "center",
      },
    };
  }
  return obj;
};
let compatiblePathToExtendShowImg = function (obj, analysis) {
  let nowObj = dsf.dataview.utils.compatiblePathToExtendImg(obj);
  let url = nowObj?.custom.image || "";

  let getWebPath = dsf.url.getWebPath;
  if (typeof analysis === "function") {
    getWebPath = analysis;
  }
  return getWebPath(url);
};
//将样式转换为css样式格式
const transformToStyle = function (options) {
  let style = "";
  Object.keys(options).forEach((key) => {
    style += key.replace(/([A-Z])/g, function (match) {
      return "-" + match.toLowerCase();
    });
    style += ":";
    let value = options[key];
    if (Array.isArray(value)) {
      value = value.join("px ") + "px";
    } else if (dsf.isNumber(value)) {
      value += "px";
    }
    style += value + ";";
  });
  return style;
};
/**
 * 解析tooltip中html中的属性的值并转化为echarts相应的属性
 * @param {*} html 需要解析的html
 * @param {*} param formatter对应的单个param
 * @param {*} param hiddenField 置空字段
 * @param {*} param fieldsStyleRules 字段样式规则
 * @return {*}
 */
const analyzeToolTipHTMLAttr = function (
  html,
  param,
  type = "chart",
  hiddenField = [],
  fieldsStyleRules = []
) {
  // 创建一个临时容器元素
  const container = document.createElement("div");
  container.innerHTML = html;
  // 获取含有 real-value 属性的元素
  const elements = container.querySelectorAll("[real-value]");
  elements.forEach((element) => {
    const realValue = element.getAttribute("real-value");
    //找出匹配的样式规则
    const rules = fieldsStyleRules.filter((it) => it.valueName == realValue);
    //规则样式
    let style = {};
    rules.forEach((rule) => {
      //没有规则
      if (rule.rule === "none") {
        style = dsf.mix(true, {}, rule.style);
        //有规则，规则必须存在
      } else if (rule.rule) {
        let fn = filterConditionStrategy[rule.rule];
        let data = param;
        if (type === "chart" && dsf.isObject(param.data)) {
          data = { ...param, ...param.data };
        }
        if (typeof fn === "function" && fn(data, rule, true)) {
          style = dsf.mix(true, {}, rule.style);
        }
      }
    });
    const computedStyle = dsf.dataview.utils.transformToStyle(style);
    element.setAttribute("style", computedStyle);
    let replacement = "";
    switch (type) {
      case "chart":
        let data = param;
        if (dsf.isObject(param.data)) {
          data = { ...param, ...param.data };
        }
        let val = data[realValue];
        //处理渐变marker--处理如果渐变有个透明marker不显示
        if (realValue.startsWith("marker")) {
          let index = realValue.split("_")[1];
          let colorStops = null;
          if (!index && param.color?.colorStops) {
            colorStops = param.color.colorStops;
          } else if (index && param["color_" + index]?.colorStops) {
            colorStops = param["color_" + index].colorStops;
          }
          if (colorStops) {
            let color1 = colorStops[0].color;
            let color2 = colorStops[1].color;
            let makerEl = $(val)[0];
            if (makerEl) {
              makerEl.style.background =
                "linear-gradient(" + color1 + ", " + color2 + ")";
              val = makerEl.outerHTML;
            }
          }
        }

        replacement = val || "";
        break;
      case "gis":
        let properties = param.properties;
        replacement =
          properties[realValue] === undefined ? "--" : properties[realValue];
        break;
      case "three":
        replacement = param[realValue] === undefined ? "--" : param[realValue];
        break;
      case "textBox":
        replacement = param[realValue] === undefined ? "" : param[realValue];
        break;
    }
    if (hiddenField?.indexOf(realValue) > -1) {
      replacement = "";
    }
    element.innerHTML = replacement;
  });
  // 返回替换后的 HTML 字符串
  return container.innerHTML;
};

/**
 * 判断是否有内容
 * @param {*} html
 * @return {*}
 */
const hasTextContent = function (html) {
  let reg = /(<(.[^>]*)>)|(&nbsp;)/g;
  html = html?.replace(reg, "").trim() || "";
  if (html) {
    return true;
  }
  return false;
};
//拍平树
const flatTree = function (tree) {
  let result = [];
  if (!Array.isArray(tree)) return [];
  while (tree.length) {
    let current = tree.shift();
    let { children, ...properties } = current;
    result.push(properties);
    if (children && children.length) {
      tree.push(...children);
    }
  }
  return result;
};
//构建树
const establishTree = function (arr, id, realId, realPid) {
  id = id + "";
  let map = new Map();
  arr.forEach((it) => {
    let _id = it[realId] + "";
    let current = map.get(_id);
    if (!current) {
      it.children = [];
      map.set(_id, it);
    } else {
      let children = current.children;
      it.children = children;
    }
    let pid = it[realPid] + "";
    let parent = map.get(pid);
    if (parent) {
      parent.children.push(it);
    } else {
      map.set(pid, {
        children: [it],
      });
    }
  });
  if (map.get(id)) {
    return map.get(id).children;
  } else {
    return [];
  }
};
const transformPx = function (size, isRem = true) {
  if (dsf.isNumber(size) || /^\d+$/g.test(size)) {
    size += "px";
  }
  if (isRem) {
    size = dsf.pxToRem(size);
  }
  return size;
};
const transformArrayPx = function (arr) {
  if (!Array.isArray(arr)) {
    return arr;
  }
  let list = [];
  list = arr.map((str) => transformPx(str)).join(" ");
  return list;
};
//风格中图片id的转化
const getUploadImageById = function (src) {
  if (/\/upload\/file\/.+/.test(src)) {
    return src;
  } else {
    if (src) {
      return `/upload/file/png/${src}`;
    }
    return src;
  }
};
//背景解析
const $colorFormat = function (opt, analysis) {
  if (!opt) {
    return {};
  }
  let getWebPath = dsf.url.getWebPath;

  if (typeof analysis === "function") {
    getWebPath = analysis;
  }
  let { active, color, pattern, custom } = opt;
  switch (active) {
    case "color":
      let { value, image, type } = color;
      if (type == "color") {
        return {
          "background-color": value,
        };
      } else {
        return { background: image };
      }
    case "pattern":
      if (pattern) {
        let imgUrl =
          dsf.dataview.utils.getUploadImageById(pattern.image) || pattern.image; // 当弹框的时候$designer就不存在
        imgUrl = getWebPath(imgUrl);
        // 新版position格式是数组 兼容老板字符串
        let position = pattern.position;
        if (dsf.isArray(position)) {
          position = position.join(" ");
        }
        return {
          "background-image": imgUrl ? `url('${imgUrl}')` : "none",
          "background-size": pattern.size,
          "background-repeat": pattern.repeat,
          "background-position": position,
        };
      }
      break;
    case "custom":
      if (custom) {
        // 新版position格式是数组 兼容老板字符串
        let position = custom.position;
        if (dsf.isArray(position)) {
          position = position.join(" ");
        }
        return {
          "background-image": `url('${getWebPath(custom.image)}')`,
          "background-size": custom.size,
          "background-repeat": custom.repeat,
          "background-position": position,
        };
      }
  }
  return {};
};
/*
  该方法与 $colorFormat 存在差异
  $colorFormat 方法中，单色、背景图、自定义背景图、线性渐变和径向渐变只能存在一种
  $colorFormatCoexist 方法中，单色与背景图/自定义背景图可同时存在， 单色、背景图/自定义背景图与渐变色仍互斥
*/
const $colorFormatCoexist = function (config, analysis) {
  if (!config) return {};
  let { active, pattern, custom } = config,
    style = {};
  // 添加背景色
  if (active === "color") {
    style = $colorFormat({
      ...config,
      active: "color",
    });
    // 添加背景/自定义背景
    if (pattern?.image || custom?.image) {
      let animationStyle = dsf.dataview.utils.analyzeAnimation(config[active]);
      style = {
        ...style,
        ...$colorFormat({
          ...config,
          active: pattern?.image ? "pattern" : "custom",
        }),
        ...animationStyle,
      };
    }
  } else {
    let animationStyle = dsf.dataview.utils.analyzeAnimation(config[active]);
    style = {
      ...$colorFormat(
        {
          ...config,
          active,
        },
        analysis
      ),
      ...animationStyle,
    };
  }
  return style;
};
/*
  新版 适用于颜色和图片分开选择
*/
const $backgroundFormat = function (config, analysis, attrObj) {
  if (!config) return {};
  let { active, color, pattern, custom } = config;
  if (!active) return {};
  let style = {};
  if (
    (color && color.type == "color") ||
    (color &&
      ["linear", "radial"].includes(color.type) &&
      !pattern?.image &&
      !custom?.image)
  ) {
    style = {
      // 添加背景色
      ...$colorFormat({
        ...config,
        active: "color",
      }),
    };
  }
  if (pattern?.image || custom?.image) {
    let animationStyle = dsf.dataview.utils.analyzeAnimation(config[active]);
    style = {
      ...style,
      // 添加背景/自定义背景
      ...$colorFormat(
        {
          ...config,
          active,
        },
        analysis
      ),
      ...animationStyle,
    };
  }
  if (attrObj?.isBgInfoVar) {
    let defaultBgVarCss = attrObj.defaultBgVarCss || {};
    style = dsf.dataview.utils.cssAttrToCssVar(style, defaultBgVarCss);
  }
  return style;
};
/**
 * @name: 统一将css的属性变成css的变量模式
 * @param {*} style
 * @return {*}
 */
export const cssAttrToCssVar = function (style, defaultVar = {}) {
  let newStyle = {};
  if (style && typeof style === "object") {
    //防止嵌套被上一层给覆盖
    let defaultAttr = dsf.mix(
      true,
      {},
      {
        "--background-color": "transparent",
        "--background-image": "none",
        "--background-size": "auto",
        "--background-repeat": "repeat",
        "--background-position": "0% 0%",
        "--animation": "none",
        "--border-radius": "0",
      },
      defaultVar
    );
    Object.keys(style).forEach((key) => {
      let keyVal = style[key];
      // 统一将驼峰转化为-命名
      let newKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
      if (newKey === "background" && keyVal.includes("gradient")) {
        newKey = "background-image";
      }
      if (key === "background-position" && typeof keyVal === "string") {
        keyVal = keyVal.replaceAll("middle", "center");
      }
      newKey = `--${newKey}`;
      newStyle[newKey] = keyVal;
    });
    newStyle = dsf.mix(true, {}, defaultAttr, {
      ...newStyle,
    });
  }
  return newStyle;
};
/**
 * @name: 分析规则转化为相对应的字段
 * @param {String} ruleStr 规则字符串
 * @param {Array} fieldList 对应的字段映射
 * @param {String} nameField 名称对应的字段
 * @param {String} valueField 值对应的字段
 * @return {String}
 */
const analysisRuleToDataField = function (
  ruleStr,
  fieldList,
  nameField = "name",
  valueField = "value"
) {
  // 替换@ [xxxx ]  => @['相应的字段']
  let matched = ruleStr.match(/@\s*\[(.*?)\]/);
  let content = matched ? matched[1].trim() : "";
  if (/[\u4e00-\u9fa5]/.test(content)) {
    let reg = /@\s*\[\s*(.*?)\s*\]/;
    let one = fieldList.find(
      (item) => item[nameField] === content || item[valueField] === content
    );
    if (one) {
      return ruleStr.replace(reg, `@[${one.value}]`);
    }
    // 如果找不到则传入空字符串(公用方法解析不了识别不了的中文)
    return "";
  }
  return ruleStr;
};
const analysisKeyToDataField = function (
  field,
  fieldList,
  nameField = "name",
  valueField = "value"
) {
  // 替换xxxx  =>'相应的字段
  let one = fieldList.find(
    (item) => item[nameField] === field || item[valueField] === field
  );
  if (one) {
    return one.value;
  }
  return field;
};
//生成公式语法树
const generateFormalTree = function (value) {
  //计算字符出现的数量
  let cal = function (str, keyWord) {
    let sumNum = 0;
    if (str) {
      let arr = str.split(keyWord);
      sumNum = arr.length - 1;
    }
    return sumNum;
  };
  let analysis = function (value) {
    // 公式语法树
    let formula = {
      name: "",
      args: [],
    };
    if (!value) return value;
    //匹配 是否符合公式规范
    let isFormulaReg = /[a-zA-Z]+\([\s\S]*\)/;
    let funcNameReg = /[a-zA-Z]+(?=\()/;
    // 获取参数
    if (isFormulaReg.test(value)) {
      let result = value.match(funcNameReg);
      //属于公式
      if (result) {
        let name = result[0];
        formula.name = name;
        let index = 0;
        let len = name.length;
        let args = value.substring(index + len + 1, value.length - 1);
        // 'a,b,c(c,e(s,d)),d,'.match(/(([a-z]+\(.+\)))+/g)
        let argsArr = args.split(",");

        // 解析参数
        let argsRes = [];
        //笨比方法
        let left = 0;
        let funs = "";
        for (let i = 0; i < argsArr.length; i++) {
          let item = argsArr[i];
          if (cal(item, "(")) {
            left += cal(item, "(");
          }
          if (cal(item, ")")) {
            left -= cal(item, ")");
          }
          funs += "," + item;
          if (left === 0) {
            argsRes.push(funs.replace(/^,/, ""));
            funs = "";
          }
        }
        argsRes.forEach((arg) => {
          formula.args.push(analysis(arg));
        });
        return formula;
      } else {
        //就是普通字符串
        return value;
      }
    } else {
      return value;
    }
  };
  return analysis(value);
};
//highcharts 颜色转换
const convertHightToCSSColor = function (color) {
  let res = "";
  //线性颜色
  if (color.linearGradient) {
    const x = color.linearGradient.x1;
    const colorStops = color.stops;
    const angle = parseInt((Math.asin(x) * 180) / Math.PI);
    res += `linear-gradient(${angle}deg,`;
    colorStops.forEach((it) => {
      let percent = parseInt(it[0] * 100);
      res += `${it[1]} ${percent}%`;
    });
    res += ")";
  } else if (color.radialGradient) {
    const { cx, cy } = color.radialGradient;
    let x = parseInt(cx * 100);
    let y = parseInt(cy * 100);
    const colorStops = color.stops;
    res += `radial-gradient(circle at ${x}% ${y}%,`;
    colorStops.forEach((it) => {
      let percent = parseInt(it[0] * 100);
      res += `${it[1]} ${percent}%,`;
    });
    res += ")";
  } else {
    res = color;
  }
  return res;
};
//echarts颜色转css
const convertChartToCSSColor = function (color) {
  let res = "";
  if (color?.type === "linear") {
    const degreeMap = {
      "0100": 0,
      "0110": 45,
      "0010": 90,
      "0011": 135,
      "0001": 180,
      1001: 225,
      1000: 270,
      1100: 315,
    };
    const coordKey = "" + color.x + color.y + color.x2 + color.y2;
    let angle = degreeMap[coordKey];
    if (!angle) {
      const x = color.x;
      angle = parseInt((Math.asin(x) * 180) / Math.PI);
    }
    res += `linear-gradient(${angle}deg, `;
    const colorStops = color.colorStops;
    colorStops.forEach((it, index) => {
      let percent = parseInt(it.offset * 100);
      res += `${it.color} ${percent}%`;
      if (index < colorStops.length - 1) {
        res += ",";
      }
    });
    res += ")";
  } else if (color?.type === "radial") {
    let x = parseInt(color.x * 100);
    let y = parseInt(color.y * 100);
    const colorStops = color.colorStops;
    res += `radial-gradient(circle at ${x}% ${y}%, `;
    colorStops.forEach((it, index) => {
      let percent = parseInt(it.offset * 100);
      res += `${it.color} ${percent}%`;
      if (index < colorStops.length - 1) {
        res += ",";
      }
    });
    res += ")";
  } else {
    res = color;
  }
  return res;
};
//css转highchart
const convertCSSToHighColor = function (cssColor) {
  //匹配线性渐变
  const matchLine = cssColor.match(/linear-gradient\((.*)\)/);
  const matchRadial = cssColor.match(/radial-gradient\((.*)\)/);

  // 不是渐变色直接返回
  if (!matchLine && !matchRadial) return cssColor;
  if (matchLine) {
    const parts = matchLine[1].split("deg,");
    // 将角度转换成坐标
    let angle = +parts[0];
    const limited = 0.01;
    let radian = (angle * Math.PI) / 180;
    let x1 = 0;
    let y1 = 0;
    if (angle > 90) {
      y1 = +Math.sin(((angle - 90) * Math.PI) / 180).toFixed(2);
      x1 = -Math.cos(((angle - 90) * Math.PI) / 180).toFixed(2);
    }
    const x2 = Math.abs(Math.sin(radian)) < limited ? 0 : Math.sin(radian);
    const y2 = Math.abs(Math.cos(radian)) < limited ? 0 : Math.cos(radian);

    // 颜色转换处理
    const colors = parts[1].split("%,");
    const stops = [];
    for (let i = 0; i < colors.length; i++) {
      let item = colors[i];
      if (!item) continue;
      const splitIndex = item.lastIndexOf(" ");

      let color = item.slice(0, splitIndex);
      let percent = item.slice(splitIndex + 1);
      if (percent.endsWith("%")) percent = item.slice(splitIndex + 1, -1);
      color = color.replace(/NaN/g, "255");
      stops.push([+percent / 100, color]);
    }

    return {
      linearGradient: { x1, x2, y1, y2 },
      stops,
    };
  } else {
    const parts = matchRadial[1].split("%,");
    parts.shift();
    const result = matchRadial[1].match(/at(.*?),/);
    let points = result[1].match(/([\d\.]+%)\s([\d\.]+%)\s?([\d\.]+%)?/);
    points = points.slice(1, 3).map(parseFloat);

    let cx = 0.5;
    let cy = 0.5;
    let r = 0.5;
    if (points.length) {
      switch (points.length) {
        case 1:
          cx = parseFloat(points[0] / 100);
          break;
        case 2:
          cx = parseFloat(points[0] / 100);
          cy = parseFloat(points[1] / 100);
          break;
      }
    }

    const stops = [];
    for (let i = 0; i < parts.length; i++) {
      let item = parts[i];
      if (!item) continue;
      const splitIndex = item.lastIndexOf(" ");

      let color = item.slice(0, splitIndex);
      let percent = item.slice(splitIndex + 1);
      if (percent.endsWith("%")) percent = item.slice(splitIndex + 1, -1);

      color = color.replace(/NAN/g, "255");
      stops.push([+percent / 100, color]);
    }
    return {
      radialGradient: { cx, cy, r },
      stops,
    };
  }
};
// css 颜色转echarts
const convertCSSToEChartsColor = function (cssColor) {
  //匹配线性渐变
  const matchLine = cssColor.match(/linear-gradient\((.*)\)/);
  const matchRadial = cssColor.match(/radial-gradient\((.*)\)/);

  // 不是渐变色直接返回
  if (!matchLine && !matchRadial) return cssColor;
  if (matchLine) {
    const parts = matchLine[1].split("deg,");
    // 角度枚举
    // 01 00 下到上 0
    // 01 10 左下到右上 45
    // 00 10 左到右 90
    // 00 11 左上到右下 135
    // 00 01 上到下 180
    // 10 01 右上到左下 225
    // 10 00 右到左 270
    // 11 00 右下到左上 315
    const coordMap = {
      0: [
        [0, 1],
        [0, 0],
      ],
      45: [
        [0, 1],
        [1, 0],
      ],
      90: [
        [0, 0],
        [1, 0],
      ],
      270: [
        [1, 0],
        [0, 0],
      ],
      180: [
        [0, 0],
        [0, 1],
      ],
      135: [
        [0, 0],
        [1, 1],
      ],
      315: [
        [1, 1],
        [0, 0],
      ],
      225: [
        [1, 0],
        [0, 1],
      ],
    };
    const [[x, y], [x2, y2]] = coordMap[parts[0]];

    // 颜色转换处理
    const colors = parts[1].split("%,");
    const colorStops = [];
    for (let i = 0; i < colors.length; i++) {
      let item = colors[i];
      if (!item) continue;
      const splitIndex = item.lastIndexOf(" ");

      let color = item.slice(0, splitIndex);
      let percent = item.slice(splitIndex + 1);
      if (percent.endsWith("%")) percent = item.slice(splitIndex + 1, -1);
      color = color.replace(/NaN/g, "255");
      colorStops.push({
        offset: +percent / 100,
        color: color.trim(),
      });
    }

    return {
      type: "linear",
      x,
      y,
      x2,
      y2,
      colorStops,
    };
  } else {
    const parts = matchRadial[1].split("%,");
    parts.shift();
    const result = matchRadial[1].match(/at(.*?),/);
    let points = result[1].match(/([\d\.]+%)\s([\d\.]+%)\s?([\d\.]+%)?/);
    points = points.slice(1, 3).map(parseFloat);

    let x = 0.5;
    let y = 0.5;
    let r = 0.5;
    if (points.length) {
      switch (points.length) {
        case 1:
          x = parseFloat(points[0] / 100);
          break;
        case 2:
          x = parseFloat(points[0] / 100);
          y = parseFloat(points[1] / 100);
          break;
      }
    }

    const colorStops = [];
    for (let i = 0; i < parts.length; i++) {
      let item = parts[i];
      if (!item) continue;
      const splitIndex = item.lastIndexOf(" ");

      let color = item.slice(0, splitIndex);
      let percent = item.slice(splitIndex + 1);
      if (percent.endsWith("%")) percent = item.slice(splitIndex + 1, -1);

      color = color.replace(/NAN/g, "255");
      colorStops.push({
        offset: +percent / 100,
        color: color.trim(),
      });
    }
    return {
      type: "radial",
      x,
      y,
      r,
      colorStops,
    };
  }
};
const transformTextStyle = function (textStyle, filterAttr = []) {
  let color = handleColor(textStyle.colorObj || textStyle.color);
  let style = {
    fontFamily: textStyle.fontFamily,
    fontSize: dsf.dataview.utils.transformPx(textStyle.fontSize),
    fontWeight: textStyle.fontWeight,
    fontStyle: textStyle.fontStyle,
    textDecoration: textStyle.textDecoration,
    textShadow: textStyle.textShadow || "0 0 0 transparent",
  };
  let isGradientFlag = false;
  if (color.indexOf("gradient") > -1) {
    style.color = "transparent";
    style.backgroundImage = color;
    style.backgroundClip = "text";
    style["-webkit-background-clip"] = "text";
    style["-moz-background-clip"] = "text";
    isGradientFlag = true;
  } else {
    style.color = color;
  }
  filterAttr.forEach((key) => {
    let newKey = key.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    // 过滤属性
    if (newKey === "color") {
      if (isGradientFlag) {
        delete style.backgroundImage;
        delete style.backgroundClip;
      }
    }
    delete style[newKey];
  });
  return style;
};
const getTextColor = function (color) {
  let resultStyle = {};
  if (
    color &&
    typeof color.indexOf === "function" &&
    color.indexOf("gradient") > -1
  ) {
    resultStyle.color = "transparent";
    resultStyle.backgroundImage = color;
    resultStyle.backgroundClip = "text";
    resultStyle["-webkit-background-clip"] = "text";
    resultStyle["-moz-background-clip"] = "text";
  } else {
    resultStyle.color = color;
  }
  return resultStyle;
};

const getRandomWithDecimal = function (min, max, digits = 1) {
  const randomArbitrary = Math.random() * (max - min) + min;
  const roundedToOneDecimal =
    Math.round(randomArbitrary * 10 * digits) / (10 * digits);
  return roundedToOneDecimal;
};
const generateRandomString = function (length = 8) {
  var result = "";
  var characters = "abcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};
/**
 * @name: 上下移动数组中的元素
 * @param {*} array 数组
 * @param {*} index 索引
 * @param {*} direction 移动的方向
 * @param {*} isDeepClone 是否进行深拷贝
 * @return {*}
 */
const moveOneArray = function (array, index, direction, isDeepClone = true) {
  let newArray = _.cloneDeep(array);
  if (!isDeepClone) {
    newArray = array;
  }
  // 首先检查边界条件
  if (direction === "up" && index <= 0) {
    return newArray; // 如果是在顶部且方向是向上，则无需操作
  } else if (direction === "down" && index >= newArray.length - 1) {
    return newArray; // 如果是在底部且方向是向下，则无需操作
  }

  // 移动元素
  let element = newArray.splice(index, 1)[0]; // 移除指定索引的元素
  let newIndex;

  // 根据方向确定新索引
  if (direction === "up") {
    newIndex = index - 1;
  } else {
    newIndex = index + 1;
  }

  // 插入元素到新位置
  newArray.splice(newIndex, 0, element);
  return newArray;
};
/**
 * @name: 随机取数
 * @param {*} arr 数组
 * @param {*} n 最大取多少个
 * @return {*}
 */
const getRandomIndices = function (arr, n) {
  const indices = Array.from({ length: arr.length }, (_, i) => i);
  const result = [];
  // Fisher-Yates 洗牌算法
  for (let i = indices.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [indices[i], indices[j]] = [indices[j], indices[i]]; // 交换元素
  }
  // 选择前 n 个下标
  for (let i = 0; i < n; i++) {
    result.push({
      index: indices[i],
      item: arr[indices[i]],
    });
  }
  return result;
};
/**
 * @name: 切割字符串数字按照每n个一组
 * @param {String} str 字符串
 * @param {number} n 几个字符串
 * @return {Array} 数组
 */
const chunkString = function (str, n) {
  if (typeof str !== "string") {
    return [str];
  }
  return Array.from({ length: Math.ceil(str.length / n) }, (_, index) =>
    str.slice(index * n, (index + 1) * n)
  );
};
/**
 * @name: 获取下一个颜色
 * @param {Array} hasList 已经存在的数组
 * @param {Array} totalColorList 总共的颜色数组
 * @return {str} 颜色
 */
const getNextColor = function (hasList, totalColorList) {
  const totalLength = totalColorList.length;
  const hasLength = hasList.length;
  if (Array.isArray(totalColorList) && totalLength) {
    return totalColorList[hasLength % totalLength];
  }
  return "rgba(0,0,0,1)";
};
/**
 * @name: 解析动画对象
 * @param {*} obj
 * @return {style} style可以解析
 */
const analyzeAnimation = function (obj) {
  let style = {};
  let animationObj = obj?.animation;
  if (animationObj && animationObj.name?.length) {
    let animationArr = [];
    animationObj.name.forEach((name) => {
      animationArr.push(`${name} 2.5s infinite`);
    });
    style.animation = animationArr.join(",");
  }
  return style;
};
/**
 * @name: 获取动效
 * @param {*} config (背景图片对象)
 * @return {style} style可以解析
 */
const getBgAnimation = function (config) {
  if (!config) return {};
  let { active } = config;
  if (!active || active === "color") return {};
  let animationStyle = dsf.dataview.utils.analyzeAnimation(config[active]);
  return animationStyle;
};
/**
 * @name: 比较两个数组至少有两个不一样的
 * @param {Array} array1
 * @param {Array} array2
 * @return {Boolean} true或者false
 */
const haveAtLeastTwoDifferences = function (array1, array2) {
  // 首先检查数组长度是否不同，如果是，则直接返回true
  if (array1.length !== array2.length) return true;
  let differencesCount = 0; // 不同元素的数量
  const maxDifferences = 2; // 至少两个不同的元素
  // 遍历数组，比较对应位置的元素
  for (let i = 0; i < array1.length && differencesCount < maxDifferences; i++) {
    if (array1[i] !== array2[i]) {
      differencesCount++; // 增加不同元素的数量
      if (differencesCount === maxDifferences) {
        // 如果已经找到至少两个不同的元素，返回true
        return true;
      }
    }
  }
  // 如果遍历完数组还没有找到至少两个不同的元素，返回false
  return false;
};

// 过滤出图片相关属性,以及需要的属性
const filterBackGroundAttr = function (style, flag) {
  const keys = Object.keys(style);
  const imageAttr = ["background", "radius", "animation", "borderRadius"];
  const filteredKeys = keys.filter((key) =>
    flag
      ? imageAttr.some((str) => key.includes(str))
      : imageAttr.every((str) => !key.includes(str))
  );
  return filteredKeys.reduce((obj, key) => {
    obj[key] = style[key];
    return obj;
  }, {});
};
/**
 * @name: 判断是否有鼠标手势伪代码事件数组
 * @param {Object} arr 像eventRelativeDeal中.click对象一样
 * @return {Boolean}
 */
const isCursorPointer = function (arr) {
  let flag = arr.some((item) => {
    if (item && typeof item.fn === "string" && item.fn.trim()) {
      return true;
    }
    return false;
  });
  return flag;
};
let dataviewUtils = {
  getUploadImageById,
  $colorFormat,
  $colorFormatCoexist,
  $backgroundFormat,
  transformToStyle,
  transformPx,
  transformArrayPx,
  flatTree,
  establishTree,
  objectToString,
  handleDecimal,
  getRandomColor,
  dataExcelCommonExcelToArrayObj,
  toThSeparator,
  transformUnit,
  compatiblePathToExtendImg,
  compatiblePathToExtendShowImg,
  analyzeToolTipHTMLAttr,
  hasTextContent,
  analysisRuleToDataField,
  analysisKeyToDataField,
  generateFormalTree,
  transformToExcelData,
  transformExcelDataToJSON,
  filterConditionStrategy,
  convertCSSToEChartsColor,
  convertChartToCSSColor,
  convertCSSToHighColor,
  convertHightToCSSColor,
  transformTextStyle,
  getTextColor,
  getRandomWithDecimal,
  generateRandomString,
  moveOneArray,
  getRandomIndices,
  chunkString,
  getNextColor,
  analyzeAnimation,
  getBgAnimation,
  haveAtLeastTwoDifferences,
  cssAttrToCssVar,
  filterBackGroundAttr,
  isCursorPointer,
};
export default dataviewUtils;
